"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const Colors_1 = __importDefault(require("../../assets/colors/Colors"));
const helpler_1 = require("../../utils/helpler");
const scale_1 = require("../../utils/scale");
const ModalPicker = (props) => {
    const insets = (0, react_native_safe_area_context_1.useSafeAreaInsets)();
    const { data, onClose, onSelect, styleViewModal, label, value, type } = props;
    const handleItem = (item) => {
        onSelect(item);
        onClose();
    };
    const pickerItem = (item, index) => {
        const name = () => {
            if (type == 'reason') {
                return item.reason;
            }
            else if (type == 'approve') {
                return item.name;
            }
            else if (type == 'TypeReason') {
                return item.label;
            }
            else {
                return item.name;
            }
        };
        return (react_1.default.createElement(react_native_1.TouchableOpacity, { key: index, style: {
                height: (0, scale_1.verticalScale)(48),
                justifyContent: 'space-between',
                alignItems: 'center',
                flexDirection: 'row',
                borderBottomWidth: index !== data.length - 1 ? 1 : 0,
                borderBottomColor: Colors_1.default.gray10,
            }, onPress: () => handleItem(item) },
            react_1.default.createElement(react_native_1.Text, { style: {
                    fontSize: (0, scale_1.moderateScale)(16),
                    color: Colors_1.default.textHeader,
                    fontWeight: '400',
                    marginHorizontal: (0, scale_1.scale)(10),
                } }, name()),
            value == name()));
    };
    return (react_1.default.createElement(react_native_1.Modal, { statusBarTranslucent: true, visible: props.visible, animationType: "fade", transparent: true, onRequestClose: props.onClose, onShow: () => {
            helpler_1.isWeb && document.body.classList.add("prevent-slice-modal");
        }, onDismiss: () => {
            helpler_1.isWeb && document.body.classList.remove("prevent-slice-modal");
        }, ...props },
        react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: onClose, activeOpacity: 1, style: {
                flex: 1,
                backgroundColor: Colors_1.default.textHeaderOpacity60,
                justifyContent: 'flex-end',
                alignItems: 'center',
            } },
            react_1.default.createElement(react_native_1.View, { style: [
                    {
                        backgroundColor: 'white',
                        width: '100%',
                        position: 'absolute',
                        paddingBottom: insets.bottom + 10,
                        paddingTop: 10,
                        borderTopLeftRadius: (0, scale_1.scale)(16),
                        borderTopRightRadius: (0, scale_1.scale)(16),
                        paddingHorizontal: (0, scale_1.scale)(20),
                        overflow: 'hidden',
                    },
                    styleViewModal,
                ] },
                react_1.default.createElement(react_native_1.View, { style: {
                        width: (0, scale_1.scale)(50),
                        height: (0, scale_1.scale)(5.5),
                        borderRadius: 20,
                        backgroundColor: Colors_1.default.gray30,
                        alignSelf: 'center',
                    } }),
                react_1.default.createElement(react_native_1.Text, { style: {
                        fontSize: (0, scale_1.moderateScale)(18),
                        color: Colors_1.default.textHeader,
                        fontWeight: '500',
                        marginTop: (0, scale_1.verticalScale)(20),
                        marginBottom: (0, scale_1.verticalScale)(10),
                    } }, label),
                data?.map((item, index) => pickerItem(item, index))))));
};
exports.default = ModalPicker;
